var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: { model: _vm.ruleForm, "label-width": "150px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "父类选择：",
                    prop: "pid",
                    rules: [
                      {
                        required: true,
                        message: "请选择父类",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.ruleForm.pid,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "pid", $$v)
                        },
                        expression: "ruleForm.pid",
                      },
                    },
                    _vm._l(_vm.baseOption, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "名称：",
                    prop: "name",
                    rules: [
                      {
                        required: true,
                        message: "请填写名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写名称", maxlength: "100" },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序：", prop: "sort" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, precision: 0, placeholder: "排序" },
                    model: {
                      value: _vm.ruleForm.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "sort", $$v)
                      },
                      expression: "ruleForm.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "对应产地：", prop: "areaList" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      clearable: "",
                      options: _vm.addresData,
                      props: {
                        value: "id",
                        label: "name",
                        children: "child",
                        expandTrigger: "hover",
                        checkStrictly: true,
                      },
                    },
                    model: {
                      value: _vm.ruleForm.areaList,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "areaList", $$v)
                      },
                      expression: "ruleForm.areaList",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "城市图片：", prop: "cityImg" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "upLoadPicBox",
                          on: {
                            click: function ($event) {
                              return _vm.modalPicTap("1", "cityImg")
                            },
                          },
                        },
                        [
                          _vm.ruleForm.cityImg
                            ? _c("div", { staticClass: "pictrue" }, [
                                _c("img", {
                                  attrs: { src: _vm.ruleForm.cityImg },
                                }),
                              ])
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.ruleForm.cityImg
                        ? _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: { color: "red", "font-size": "16px" },
                            on: {
                              click: function ($event) {
                                return _vm.removeImg("cityImg")
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "banner图片：", prop: "bannerImg" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "upLoadPicBox",
                          on: {
                            click: function ($event) {
                              return _vm.modalPicTap("1", "bannerImg")
                            },
                          },
                        },
                        [
                          _vm.ruleForm.bannerImg
                            ? _c("div", { staticClass: "pictrue" }, [
                                _c("img", {
                                  attrs: { src: _vm.ruleForm.bannerImg },
                                }),
                              ])
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.ruleForm.bannerImg
                        ? _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: { color: "red", "font-size": "16px" },
                            on: {
                              click: function ($event) {
                                return _vm.removeImg("bannerImg")
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "精选产品（skuID）：", prop: "skuIds" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请输入skuId",
                    },
                    model: {
                      value: _vm.ruleForm.skuIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "skuIds", $$v)
                      },
                      expression: "ruleForm.skuIds",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#666" } }, [
                    _vm._v(
                      "输入skuId，多个以逗号分隔（示例：30001,30002,30003）"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.loading },
                        on: {
                          click: function ($event) {
                            return _vm.handerSubmit("ruleForm")
                          },
                        },
                      },
                      [_vm._v("确认提交")]
                    ),
                    _vm._v(" "),
                    _c("el-button", { on: { click: _vm.goReturn } }, [
                      _vm._v("返回列表"),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }